import { FC, Fragment, useEffect, useRef } from 'react';
import { ChevronDarkRightIcon, DashboardLayout, DialogWithActions } from 'Components';
import { useLocalization } from 'Hooks';
import { Box, Typography, Button } from '@material-ui/core';
import { colors, fontSizes, gutters } from 'Theme/Variables';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeAlreadyHave,
  closeCantApplyDialog,
  closeCantApplyForeign,
  closeDeletePrivilegedDialog,
  closeHasPrivilegedCardDialog,
  onCustomerApplicationListRequest,
  onOnlineApplicationCardRequest,
  onOnlineApplicationRequest,
  storeCardTransactions,
  closeOnOnlineApplicationDialog,
  resetRelationData,
  closeKycWarningDialog,
} from 'Stores/CardTransactions';
import { UserState, userStore } from 'Stores/User';
import { CardApplicationItem } from './CardApplicationItem';

require('./CardApplication.scss');
import { OnOnlineApplicationCardQueryItemModel } from 'Models';
import { ApprovalStatusEnum } from 'Utils';
import { useState } from 'react';
import {
  applicationStore,
  clearApplicationData,
  resetCardApplicationStatus,
  setCampusIdRequest,
  setInstitutionTypeRequest,
  setActiveCard,
} from 'Stores/CardApplication';
import { routePath } from 'Navigator/routes';

type CardApplicationProps = {};

const CardApplication: FC<CardApplicationProps> = ({}) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const userData: UserState = useSelector(userStore);

  const customerNumber = userData?.customerNumber;
  const sessionToken = userData?.sessionToken;

  const [activeApplication, setActiveApplicaton] = useState<boolean>(false);
  const [isOpenIstanbulkartPlusPopup, setIsOpenIstanbulkartPlusPopup] = useState<boolean>(false);
  const [isOpenStandardComparisonDialog, setIsOpenStandardComparisonDialog] = useState<boolean>(false);
  const [activeStandardItem, setActiveStandardItem] = useState<OnOnlineApplicationCardQueryItemModel | null>(null);
  const [isRetryingPlusApplication, setIsRetryingPlusApplication] = useState<boolean>(false);

  // selectedType state'i - URL'den initial value oku
  const [selectedType, setSelectedTypeState] = useState<string | null>(() => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get('type');
  });

  // selectedType'ı hem state'te hem URL'de güncelle
  const setSelectedType = (type: string | null) => {
    setSelectedTypeState(type);
    if (type) {
      history.replace(`${location.pathname}?type=${type}`);
    } else {
      history.replace(location.pathname);
    }
  };

  // Yeni response formatı için state
  const openLoopProductList = useSelector((state: any) => state.cardTransactions.openLoopProductList);
  const closeLoopProductList = useSelector((state: any) => state.cardTransactions.closeLoopProductList);

  let {
    isOpenDeletePrivilegedDialog,
    isOpenCantApplyDialog,
    isOpenAlreadyHave,
    isOpenCantApplyForeign,
    customerCardApplicationList,
    isOpenOnlineAppcationCardDialog,
    onOnlineApplicationCardStatusCode,
    isOpenKycWarningDialog,
    isOpenHasPrivilegedCardDialog,
  } = useSelector(storeCardTransactions);

  // Store'dan active card'ı al (modal için)
  const { applicationCard } = useSelector(applicationStore);

  const {
    web_card_application_title,
    web_card_application_desc,
    web_card_avaliable_popup_title,
    web_card_avaliable_popup_desc,
    web_card_avaliable_popup_button,
    web_btn_vazgec,
    web_btn_okay,
    web_cant_apply_popup_title,
    cant_apply_popup_title,
    web_card_already_exists,
    web_cant_apply_card_foreign_people,
    web_cant_apply_this_card,
    web_active_application,
    web_pc_istanbulcard_apply_page_plus_title,
    web_pc_istanbulcard_apply_page_plus_desc,
    web_pc_istanbulcard_apply_page_istanbulcard_title,
    web_pc_istanbulcard_apply_page_istanbulcard_desc,
    web_pc_istanbulcard_apply_page_plus_popup_image,
    web_pc_istanbulcard_apply_page_plus_popup_title,
    web_pc_istanbulcard_apply_page_plus_popup_desc,
    web_pc_istanbulcard_apply_page_plus_popup_btn_continue,
    web_pc_istanbulcard_student_apply_page_popup_btn_continue,
    web_pc_istanbulcard_student_apply_page_popup_title,
    web_pc_istanbulcard_student_apply_page_popup_desc,
  } = useLocalization();

  const cmsData: any = useLocalization();

  // Track the last handled ERR1454 to prevent duplicate popups
  const lastHandledErr1454Ref = useRef<boolean>(false);

  // Component mount olduğunda ve URL değiştiğinde selectedType'ı güncelle
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const urlSelectedType = urlParams.get('type');
    setSelectedTypeState(urlSelectedType);
  }, [location.search]);

  // ERR1454 gelince plus popup'ını aç ama sadece 1 kere (Plus retry'de değilse)
  useEffect(() => {
    if (onOnlineApplicationCardStatusCode === 'ERR1454' && isOpenOnlineAppcationCardDialog && !lastHandledErr1454Ref.current) {
      // Eğer Plus retry'de 1454 gelirse, popup açma
      if (isRetryingPlusApplication) {
        setIsRetryingPlusApplication(false);
        return;
      }
      lastHandledErr1454Ref.current = true;
      setIsOpenIstanbulkartPlusPopup(true);
      dispatch(closeOnOnlineApplicationDialog());
    }
    // Popup kapatılırsa veya error code temizlenirse ref'i reset et
    if (isOpenIstanbulkartPlusPopup === false || onOnlineApplicationCardStatusCode !== 'ERR1454') {
      lastHandledErr1454Ref.current = false;
    }
  }, [onOnlineApplicationCardStatusCode, isOpenOnlineAppcationCardDialog, isOpenIstanbulkartPlusPopup, isRetryingPlusApplication, dispatch]);


  useEffect(() => {
    dispatch(resetRelationData());
    dispatch(
      onOnlineApplicationCardRequest({
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
      })
    );
    dispatch(
      onCustomerApplicationListRequest({
        CustomerNumber: customerNumber,
        SessionToken: sessionToken,
        ProductCode: '',
      })
    );
    dispatch(setInstitutionTypeRequest(''));
    dispatch(setCampusIdRequest(0));
    dispatch(resetCardApplicationStatus());
    dispatch(clearApplicationData({ withoutCard: false }));
    /* yukarıdaki işlem ikinci kargo talebinden sonra eklenmiştir. eklenmesinin sebebi kullanıcı eğer ikinci kargolama
    sürecini başlatıp tekrardan yeni kart başvurusu yapmaya dönerse ücret alanında sıfır lira ödeme gözükmektedir.
    bunu engelleme için yukarıdaki işlem kullanılmıştır. */
  }, []);

  const checkAlreadyApplicationStatus = (Product: OnOnlineApplicationCardQueryItemModel) => {
    const alreadyData = customerCardApplicationList?.find((item) => item.ProductCode === Product.ProductCode);
    if (alreadyData) {
      if (alreadyData?.ApprovalStatus === ApprovalStatusEnum.WAS_CREATED) {
        checkCardStatus(Product);
      } else {
        setActiveApplicaton(true);
      }
    } else {
      checkCardStatus(Product);
    }
  };

  const redirectToApp = () => {
    const iOS_ANDROID_LINK = 'https://istanbulkart.go.link?adj_t=1r9k32kh';
    const HUAWEI_LINK = 'https://appgallery.huawei.com/app/C102347171';

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isHuawei = /huawei|honor/i.test(navigator.userAgent);

    let linkToOpen;

    if (isMobile) {
      if (isHuawei) {
        linkToOpen = HUAWEI_LINK;
      } else {
        linkToOpen = iOS_ANDROID_LINK;
      }
    } else {
      linkToOpen = iOS_ANDROID_LINK;
    }

    window.open(linkToOpen, '_blank');
    dispatch(closeKycWarningDialog());
  };

  const checkCardStatus = (Product: OnOnlineApplicationCardQueryItemModel) => {
    dispatch(
      onOnlineApplicationRequest({
        request: {
          CustomerNumber: customerNumber,
          SessionToken: sessionToken,
          ProductCode: Product.ProductCode,
          // Uygunluk sorgusuna ürünün alt ürün kodu gönderilmeli; alan hiç
          // gönderilmezse backend başvuruyu reddediyor (ProductResult=0).
          SubProductCode: Product?.SubProductCode ?? null,
        },
        product: Product,
        selectedType, // selectedType'ı da saga'ya gönder
      })
    );
  };

  const deletePrivilegedCardsAndCreateNew = () => {
    dispatch(clearApplicationData({ withoutCard: true }));
    dispatch(closeDeletePrivilegedDialog());
    // Kullanıcı imtiyazlı kartı silmeyi onayladı. Sonraki adımda (ProductTypeStep) tekrar
    // sorgu atılınca popup'ın yeniden açılıp akışı kilitlememesi için bypass bayrağını taşı.
    history.push(routePath.cardApplicationSteps, { selectedType, bypassPrivilegedDialog: true });
  };

  const openPlusApplicationPopup = () => {
    setIsOpenIstanbulkartPlusPopup(true);
  };

  const closePlusApplicationPopup = () => {
    setIsOpenIstanbulkartPlusPopup(false);
    dispatch(closeOnOnlineApplicationDialog());
    lastHandledErr1454Ref.current = false;
  };

  const continueWithPlusApplication = () => {
    const allProducts = [...(closeLoopProductList || []), ...(openLoopProductList || [])];
    const plusProduct =
      allProducts.find((product: any) => product?.ProductCode === 'IKP_IKR') ||
      ({
        CardPrintType: 0,
        ProductCode: 'IKP_IKR',
        ProductName: 'İstanbulkart Plus',
        QueryService: null,
        RequiredFields: [],
        ShippingType: null,
        SubProductCode: null,
        CardApplicationStatus: 0,
        PttPostCode: '',
      } as OnOnlineApplicationCardQueryItemModel);

    setIsRetryingPlusApplication(true);
    dispatch(
      onOnlineApplicationRequest({
        request: {
          CustomerNumber: customerNumber,
          SessionToken: sessionToken,
          ProductCode: 'IKP_IKR',
          SubProductCode: plusProduct?.SubProductCode ?? null,
        },
        product: plusProduct,
        selectedType: 'plus',
      })
    );
  };

  const continuePlusApplicationFromPopup = () => {
    const allProducts = [...(closeLoopProductList || []), ...(openLoopProductList || [])];
    const standardProduct =
      allProducts.find((product: any) => product?.ProductCode === 'IKT_STD') ||
      ({
        CardPrintType: 0,
        ProductCode: 'IKT_STD',
        ProductName: 'İstanbulkart',
        QueryService: null,
        RequiredFields: [],
        ShippingType: null,
        SubProductCode: null,
        CardApplicationStatus: 0,
        PttPostCode: '',
      } as OnOnlineApplicationCardQueryItemModel);

    dispatch(setActiveCard(standardProduct));
    lastHandledErr1454Ref.current = false;
    dispatch(
      onOnlineApplicationRequest({
        request: {
          CustomerNumber: customerNumber,
          SessionToken: sessionToken,
          ProductCode: 'IKT_STD',
          SubProductCode: standardProduct?.SubProductCode ?? null,
        },
        product: standardProduct,
        selectedType: 'plus',
      })
    );
  };

  const goToPlusApplication = () => {
    closePlusApplicationPopup();
    continueWithPlusApplication();
  };

  const handleStandardCardClick = (item?: OnOnlineApplicationCardQueryItemModel) => {
    setActiveStandardItem(item || null);
    setIsOpenStandardComparisonDialog(true);
  };

  const handleCloseStandardDialog = () => {
    setIsOpenStandardComparisonDialog(false);
  };

  const handleContinuePlusFromStandard = () => {
    setIsOpenStandardComparisonDialog(false);
    continueWithPlusApplication();
  };

  const handleContinueStandardCard = () => {
    setIsOpenStandardComparisonDialog(false);
    const standardCard = activeStandardItem || closeLoopProductList?.find((item: any) => item.ProductCode === 'IKT_STD');
    if (standardCard) {
      dispatch(setActiveCard(standardCard));
      // trigger the same onOnlineApplicationRequest flow as other paths
      checkCardStatus(standardCard);
    }
  };

  const handleBack = () => {
    if (selectedType) {
      // Seçim varsa önce seçimi temizle, ana ekrana dön
      setSelectedTypeState(null);
      history.replace(location.pathname); // URL'den type parametresini kaldır
    } else {
      // Seçim yoksa gerçekten geri git
      history.goBack();
    }
  };

  const productFilter = (product: OnOnlineApplicationCardQueryItemModel) =>
    (!product.ProductCode && product.SubProductCode) || (product.ProductCode && !product.SubProductCode);

  return (
    <DashboardLayout backButton backAction={handleBack}>
      <Fragment>
        <div id="cardApplication">
          <Typography variant="h3" component="h1" align="center">
            <Box fontWeight={600} color={colors.secondary}>
              {web_card_application_title}
            </Box>
          </Typography>
          <Typography variant="h3" component="h2" align="center">
            <Box
              mb={gutters.big}
              color={colors.checkboxLabel}
              fontSize={fontSizes.regular}
              mt={gutters.small}
              fontWeight={400}
            >
              {web_card_application_desc}
            </Box>
          </Typography>

          {/* Seçim ekranı */}
          {!selectedType && (
            <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
              {openLoopProductList?.length > 0 && (
                <Box mb={2} width="100%" maxWidth={600}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    style={{
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      background: '#f7f7f9',
                      paddingTop: gutters.regular,
                      paddingBottom: gutters.regular,
                      borderRadius: 16,
                      boxShadow: 'none',
                      paddingLeft: gutters.big,
                      paddingRight: gutters.big,
                    }}
                    onClick={() => setSelectedType('plus')}
                    startIcon={
                      <img
                        src={require('Assets/Icons/plus-card.svg').default}
                        alt="plus"
                        style={{ width: 20, height: 20 }}
                      />
                    }
                    endIcon={<ChevronDarkRightIcon />}
                  >
                    <Box textAlign="left" flexDirection="column" marginLeft={gutters.regular} flex={1}>
                      <Typography
                        variant="h3"
                        component="span"
                        style={{display:'block', fontWeight: 700, color: '#383C52', fontSize: 16, marginBottom: 5 }}
                      >
                        {/* Buton başlığı beyaz */}
                        {web_pc_istanbulcard_apply_page_plus_title}
                      </Typography>
                      <Typography variant="body1" component="span" style={{display:'block', color: colors.checkboxLabel, fontWeight: 400 }}>
                        {web_pc_istanbulcard_apply_page_plus_desc}
                      </Typography>
                    </Box>
                  </Button>
                </Box>
              )}
              {closeLoopProductList?.length > 0 && (
                <Box width="100%" maxWidth={600}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    style={{
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      background: '#f7f7f9',
                      paddingTop: gutters.regular,
                      paddingBottom: gutters.regular,
                      borderRadius: 16,
                      boxShadow: 'none',
                      paddingLeft: gutters.big,
                      paddingRight: gutters.big,
                    }}
                    onClick={() => setSelectedType('istanbulkart')}
                    startIcon={
                      <img
                        src={require('Assets/Icons/plus-card.svg').default}
                        alt="istanbulkart"
                        style={{ width: 20, height: 20 }}
                      />
                    }
                    endIcon={<ChevronDarkRightIcon />}
                  >
                    <Box textAlign="left" flexDirection="column" marginLeft={gutters.regular} flex={1}>
                      <Typography
                        variant="h3"
                        component="span"
                        style={{ display:'block', fontWeight: 700, color: '#383C52', fontSize: 16, marginBottom: 5 }}
                      >
                        {/* Buton başlığı beyaz */}
                        {web_pc_istanbulcard_apply_page_istanbulcard_title}
                      </Typography>
                      <Typography variant="body1" component="span" style={{display:'block',  color: colors.checkboxLabel, fontWeight: 400 }}>
                        {web_pc_istanbulcard_apply_page_istanbulcard_desc}
                      </Typography>
                    </Box>
                  </Button>
                </Box>
              )}
            </Box>
          )}

          {/* İstanbulkart seçilirse CloseLoopProductList gösterilecek */}
          {selectedType === 'istanbulkart' && (
            <Box mt={4}>
              <ul>
                {closeLoopProductList &&
                  closeLoopProductList
                    .filter(productFilter)
                    .map((item: any) => (
                      <li key={item.ProductName}>
                        <CardApplicationItem
                          checkAlreadyApplicationStatus={checkAlreadyApplicationStatus}
                          item={item}
                          onBlockedCardClick={openPlusApplicationPopup}
                          onStandardCardClick={handleStandardCardClick}
                          onContinuePlusFromStandard={handleContinuePlusFromStandard}
                          onContinueStandardCard={handleContinueStandardCard}
                          isOpenStandardComparisonDialog={isOpenStandardComparisonDialog}
                          onCloseStandardDialog={handleCloseStandardDialog}
                          selectedType={selectedType}
                        />
                      </li>
                    ))}
              </ul>
            </Box>
          )}

          {/* İstanbulkart Plus seçilirse OpenLoopProductList gösterilecek */}
          {selectedType === 'plus' && (
            <Box mt={4} textAlign="center">
              <ul>
                {openLoopProductList &&
                  openLoopProductList
                    .filter(productFilter)
                    .map((item: any) => (
                      <li key={item.ProductName}>
                        <CardApplicationItem
                          checkAlreadyApplicationStatus={checkAlreadyApplicationStatus}
                          item={item}
                          onBlockedCardClick={openPlusApplicationPopup}
                          onStandardCardClick={handleStandardCardClick}
                          onContinuePlusFromStandard={handleContinuePlusFromStandard}
                          onContinueStandardCard={handleContinueStandardCard}
                          isOpenStandardComparisonDialog={isOpenStandardComparisonDialog}
                          onCloseStandardDialog={handleCloseStandardDialog}
                          selectedType={selectedType}
                        />
                      </li>
                    ))}
              </ul>
            </Box>
          )}
        </div>

        {/* Plus Kart Privileged Card Dialog */}
        <DialogWithActions
          alignTitle="left"
          primaryButton={{
            label: web_pc_istanbulcard_student_apply_page_popup_btn_continue || 'Devam et',
            handleClick: () => {
              dispatch(closeHasPrivilegedCardDialog());
              // Saga'yı tekrar çağır ama bu sefer bypassPrivilegedDialog=true ile
              if (applicationCard) {
                dispatch(
                  onOnlineApplicationRequest({
                    request: {
                      CustomerNumber: customerNumber,
                      SessionToken: sessionToken,
                      ProductCode: applicationCard.ProductCode,
                      SubProductCode: applicationCard?.SubProductCode ?? null,
                    },
                    product: applicationCard,
                    bypassPrivilegedDialog: true,
                    selectedType,
                  })
                );
              }
            },
          }}
          secondaryButton={{ label: web_btn_vazgec, handleClick: () => dispatch(closeHasPrivilegedCardDialog()) }}
          open={isOpenHasPrivilegedCardDialog}
          hide={() => dispatch(closeHasPrivilegedCardDialog())}
          title={web_pc_istanbulcard_student_apply_page_popup_title}
          text={web_pc_istanbulcard_student_apply_page_popup_desc}
        />

        <DialogWithActions
          alignTitle="left"
          closeIcon
          disableClickOutside={true}
          primaryButton={{
            label: web_pc_istanbulcard_apply_page_plus_popup_btn_continue,
            handleClick: goToPlusApplication,
          }}
          secondaryButton={{
            label: web_btn_vazgec,
            handleClick: closePlusApplicationPopup,
          }}
          open={isOpenIstanbulkartPlusPopup}
          hide={closePlusApplicationPopup}
          title={web_pc_istanbulcard_apply_page_plus_popup_title}
          text={web_pc_istanbulcard_apply_page_plus_popup_desc}
          imageResource={web_pc_istanbulcard_apply_page_plus_popup_image}
          imagePlacement="top"
        />

        <DialogWithActions
          alignTitle="left"
          primaryButton={{ label: web_card_avaliable_popup_button, handleClick: deletePrivilegedCardsAndCreateNew }}
          secondaryButton={{ label: web_btn_vazgec, handleClick: () => dispatch(closeDeletePrivilegedDialog()) }}
          open={isOpenDeletePrivilegedDialog}
          hide={() => dispatch(closeDeletePrivilegedDialog())}
          title={web_card_avaliable_popup_title}
          text={web_card_avaliable_popup_desc}
        />

        <DialogWithActions
          alignTitle="left"
          primaryButton={{
            label: web_btn_okay,
            handleClick: () => dispatch(closeCantApplyDialog()),
          }}
          open={isOpenCantApplyDialog}
          hide={() => dispatch(closeCantApplyDialog())}
          title={web_cant_apply_popup_title}
          text={web_cant_apply_this_card}
        />

        <DialogWithActions
          alignTitle="left"
          primaryButton={{
            label: web_btn_okay,
            handleClick: () => dispatch(closeAlreadyHave()),
          }}
          open={isOpenAlreadyHave}
          hide={() => dispatch(closeAlreadyHave())}
          title={cant_apply_popup_title}
          text={web_card_already_exists}
        />

        <DialogWithActions
          alignTitle="left"
          primaryButton={{
            label: web_btn_okay,
            handleClick: () => dispatch(closeCantApplyForeign()),
          }}
          open={isOpenCantApplyForeign}
          hide={() => dispatch(closeCantApplyForeign())}
          title={'cant_apply_popup_title'}
          text={web_cant_apply_card_foreign_people}
        />

        <DialogWithActions
          alignTitle="left"
          primaryButton={{
            label: web_btn_okay,
            handleClick: () => setActiveApplicaton(false),
          }}
          open={activeApplication}
          hide={() => () => setActiveApplicaton(false)}
          title={cant_apply_popup_title}
          text={web_active_application}
        />
        <DialogWithActions
          alignTitle="left"
          secondaryButton={{
            label: 'Vazgeç',
            handleClick: () => {
              dispatch(closeKycWarningDialog());
            },
          }}
          open={isOpenKycWarningDialog}
          hide={() => {
            dispatch(closeKycWarningDialog());
          }}
          primaryButton={{
            label: 'Uygulamaya Git',
            handleClick: redirectToApp,
          }}
          title={cant_apply_popup_title}
          text={cmsData[onOnlineApplicationCardStatusCode || 'Missing Key:' + 'onOnlineApplicationCardStatusCode']}
        />
        <DialogWithActions
          alignTitle="left"
          open={!!isOpenOnlineAppcationCardDialog && onOnlineApplicationCardStatusCode !== 'ERR1454'}
          hide={() => {
            dispatch(closeOnOnlineApplicationDialog());
          }}
          primaryButton={{
            label: web_btn_okay,
            handleClick: () => dispatch(closeOnOnlineApplicationDialog()),
          }}
          title={cant_apply_popup_title}
          text={cmsData[onOnlineApplicationCardStatusCode || 'Missing Key:' + 'onOnlineApplicationCardStatusCode']}
        />
      </Fragment>
    </DashboardLayout>
  );
};
export default CardApplication;
